
let sizeChartSelectorIn = document.getElementById('size-chart-in');
let sizeChartSelectorCm = document.getElementById('size-chart-cm');

if (sizeChartSelectorIn) {
  sizeChartSelectorIn.addEventListener('click', function() {
    if (!sizeChartSelectorIn.classList.contains('active')) {
      sizeChartSelectorIn.classList.toggle('active');
      sizeChartSelectorCm.classList.toggle('active');
    }
  });
}

if (sizeChartSelectorCm) {
  sizeChartSelectorCm.addEventListener('click', function() {
    if (!sizeChartSelectorCm.classList.contains('active')) {
      sizeChartSelectorIn.classList.toggle('active');
      sizeChartSelectorCm.classList.toggle('active');
    }
  });
}

const urlParams = new URLSearchParams(window.location.search);
const userIdFromUrl = urlParams.get('smrtft_cmpgn');

if (userIdFromUrl) {
  localStorage.setItem('smrtftCmpgn', userIdFromUrl);
  document.getElementById('promotion-lock').remove();
}

const keyToCheck = 'smrtftCmpgn';

if (localStorage.getItem(keyToCheck) !== null) {
  const itemValue = localStorage.getItem(keyToCheck);
  if (itemValue == '100lb-launch') {
    console.log('promotion unlocked!');
    document.getElementById('promotion-lock').remove();
  } 
} 

document.addEventListener("DOMContentLoaded", function(event) {
  const urlParams = new URLSearchParams(window.location.search);
  const userIdFromUrl = urlParams.get('smrtft_cmpgn');

  if (userIdFromUrl) {
    localStorage.setItem('smrtftCmpgn', userIdFromUrl);
    document.getElementById('promotion-lock').remove();
  }

  const keyToCheck = 'smrtftCmpgn';

  if (localStorage.getItem(keyToCheck) !== null) {
    const itemValue = localStorage.getItem(keyToCheck);
    if (itemValue == '100lb-launch') {
      console.log('promotion unlocked!');
      document.getElementById('promotion-lock').remove();
    } 
  } 
});


// // Example using fetch API in client-side JavaScript
// document.getElementById('subscribeForm').addEventListener('submit', async (event) => {
//   event.preventDefault();

//   const options = {
//     method: 'POST',
//     headers: {accept: 'application/json', 'content-type': 'application/json'},
//     body: JSON.stringify({
//       profiles: [
//         {email: 'george.washington@klaviyo.com'},
//         {phone_number: '+13239169023', sms_consent: true}
//       ]
//     })
//   };

//   fetch('https://a.klaviyo.com/api/v2/list/UD2esu/subscribe?api_key=pk_e789180a86603bc8b22bf3ff54c43ec557', options)
//     .then(res => res.json())
//     .then(res => console.log(res))
//     .catch(err => console.error(err));
//   });